export default "__VITE_ASSET__63a0df5f__"